import {
  UseIntersectionObserverOptions,
  useIntersectionObserver,
} from "@react-hookz/web";
import { useEffect, useRef } from "react";

export type UseCallbackWhenInViewConfig = {
  /**
   * Will be called when the element is in view
   */
  callback: () => void;
  disabled?: boolean;
  rootMargin?: string;
  intersectionOptions?: UseIntersectionObserverOptions;
};

export function useCallbackWhenInView({
  intersectionOptions = { rootMargin: "0px" },
  ...config
}: UseCallbackWhenInViewConfig) {
  const ref = useRef(null);
  const intersection = useIntersectionObserver(ref, intersectionOptions);

  useEffect(() => {
    const isInView =
      intersection?.isIntersecting || intersection?.intersectionRatio === 1;

    if (isInView && !config.disabled) {
      config.callback();
    }
  }, [intersection, config]);

  // Attach the ref to the element you want to observe
  return ref;
}
